import script from "./GestorVentanas.vue?vue&type=script&setup=true&lang=js"
export * from "./GestorVentanas.vue?vue&type=script&setup=true&lang=js"

import "./GestorVentanas.vue?vue&type=style&index=0&id=59c6dc62&lang=css"

const __exports__ = script;

export default __exports__